export default __webpack_public_path__ + "static/media/rmall-project-2.6af46d94.webp";